import { render, staticRenderFns } from "./howto.vue?vue&type=template&id=1a6b35f5&scoped=true&"
import script from "./howto.vue?vue&type=script&lang=js&"
export * from "./howto.vue?vue&type=script&lang=js&"
import style0 from "./howto.vue?vue&type=style&index=0&id=1a6b35f5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a6b35f5",
  null
  
)

export default component.exports